class RichTextEditor extends Tango.Component {
    widgetWillMount(shadowDoc) {
        const root = shadowDoc.getElementById(this.root);
        const quill = new Quill(root, {
            modules: {
                toolbar: [
                    [{ header: [1, 2, false] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    ['code-block'],
                    ['clean'],
                ],
            },
            placeholder: 'Compose a note...',
            theme: 'snow',
        });

        const text = this.state.value;
        if (this.props.formatType == 'J')
            quill.setContents(JSON.parse(text));
        else if (this.props.formatType == 'T')
            quill.setText(text);

        const form = root.closest('form');
        const name = root.getAttribute('data-name');
        form.addEventListener('formdata', (event) => {
            event.formData.append(name, JSON.stringify(quill.getContents().ops));
        });
    }
}

class RichTextBlock extends Tango.Component {
    widgetWillMount(shadowDoc) {
        const root = shadowDoc.getElementById(this.root);
        if (this.props.formatType == 'J') {
            /*const data = JSON.parse(this.state.value);
            const converter = new QuillDeltaToHtmlConverter(data, {});
            const html = converter.convert();
            root.innerHTML = html;*/

            const renderContent = (arr, rootElement) => {
                const converter = new QuillDeltaToHtmlConverter(arr, {});
                rootElement.innerHTML = converter.convert();
            };

            const originalData = JSON.parse(this.state.value); // Сохраняем оригинальные данные
            const limit = 280;

            let charCount = 0;
            const processedOps = []; // Массив для обработанных операций
            let isTruncated = false; // Флаг, указывающий на то, что текст был обрезан

            // Перебираем операции из оригинальных данных
            for (const op of originalData) {
                const potentialLength = charCount + op.insert.length;

                // Если суммарная длина превышает лимит
                if (potentialLength > limit && charCount < limit) {
                    isTruncated = true;
                    const charsLeft = limit - charCount;

                    // Находим последний пробел в пределах остатка символов
                    let lastSpaceIndex = op.insert.lastIndexOf(' ', charsLeft);

                    // Если пробел не найден (одно длинное слово), не добавляем его
                    if (lastSpaceIndex === -1) {
                        lastSpaceIndex = 0;
                    }

                    // Обрезаем текст по последнему слову
                    const trimmedText = op.insert.substring(0, lastSpaceIndex);

                    if (trimmedText) {
                        processedOps.push({ ...op, insert: trimmedText });
                    }

                    break; // Прерываем цикл, так как лимит достигнут
                } else {
                    // Если лимит еще не достигнут, просто добавляем операцию
                    processedOps.push(op);
                    charCount += op.insert.length;
                }
            }

            // Первичная отрисовка (обрезанного или полного текста)
            const dataToRender = isTruncated ? processedOps : originalData;
            renderContent(dataToRender, root);

            // Если текст был обрезан, добавляем ссылку "Show more"
            if (isTruncated) {
                const showMoreLink = document.createElement('a');
                showMoreLink.href = '#';
                showMoreLink.innerText = 'Show more';
                showMoreLink.classList.add('show-more');

                // Добавляем обработчик клика
                showMoreLink.addEventListener('click', (event) => {
                    event.preventDefault(); // Отменяем стандартное поведение ссылки
                    // Отрисовываем полный контент из оригинальных данных
                    renderContent(originalData, root);
                });

                root.appendChild(showMoreLink);
            }
        }
        else if (this.props.formatType == 'T')
            root.innerHTML = this.state.value;
    }
}

Tango.registerComponent(RichTextEditor);
Tango.registerComponent(RichTextBlock);